export const SET_IS_LIFF = "SET_IS_LIFF";
export const SET_LIFF_INITIALIZED = "SET_LIFF_INITIALIZED";
export const SET_FACEBOOK_MESSENGER_INITIALIZED =
  "SET_FACEBOOK_MESSENGER_INITIALIZED";
